<template>
    <div>
        <span @click.stop="projectColumn.property_name==='comment'" v-if="projectColumn.property_name==='comment'">
            <button type="button" id="add-comment" name="add-comment"
                    @click.prevent.stop="addComment()"
                    class="focus:outline-none border-2 border-followup-nav hover:bg-followup-nav rounded-full font-semibold hover:text-white material-icons p-1 text-sm text-followup-nav">
                add
            </button>
        </span>

        <!-- Modal -->
        <div :id="'projectCommentModal'+this.projects.id" class="modal fade" role="dialog">
            <div class="modal-dialog" style="max-width: 870px">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">General Comment</h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="mb-2">
                                <ckeditor-container id="comment" v-model="projectCommentForm.comment" :options="users"
                                                    @mention="addMention" mentionFrom="name"></ckeditor-container>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" id="save-project-comment" name="save-project-comment"
                                @click.prevent="projectCommentSaved"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Save
                        </button>
                    </div>
                </div>

            </div>
        </div>
        <!-- Modal -->

    </div>
</template>
<script>
import Form from "../../utils/form";
import CKEditorContainer from '../shared/ckeditor-container';
export default {
    name: "inline-comment",
    props: ['projectColumn', 'projects', 'users'],
    components: {CKEditorContainer},
    data() {
        return {
            projectCommentForm: new Form({
                id: null,
                comment: '',
                date: '',
                company_contact_id: null,
                sales_status_id: null,
                mentioned_users: []
            }),
        }
    },
    methods: {

        addComment() {
            $("#projectCommentModal"+this.projects.id).modal("show");
            this.projectCommentForm.reset();
        },
        addMention(replaced) {
            if (_.find(this.projectCommentForm.mentioned_users, o => o === replaced.id)) {
                return;
            }
            this.projectCommentForm.mentioned_users.push(replaced.id);
        },
        projectCommentSaved() {
            let self = this;

            self.projectCommentForm.post(route('api.project-comment.store', {project: self.projects.id})).then((res) => {
                $("#projectCommentModal"+this.projects.id).modal("hide");
                self.projectCommentForm.reset();
            });
        }
    }
}
</script>
